// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wrapper for the entire picker */
.common_picker_date .react-datepicker {
  border: none;
  width: 100%;
}

/* Container for all dates and header */
.common_picker_date .react-datepicker__month-container {
  width: 100%;
}

/* Portion containing month name and arrows */
.common_picker_date .react-datepicker__header {
  background-color: transparent;
  border: none;
}

/* Container for all dates */
.common_picker_date .react-datepicker__month {
  margin: var(--spacing-tiny) 0;
}

/* Single day (numbers) */
.common_picker_date .react-datepicker__day-name,
.common_picker_date .react-datepicker__day {
  margin: var(--spacing-tiny);
  width: calc(100% / 7 - 2 * var(--spacing-tiny));
}

/* Selected day */
.common_picker_date .react-datepicker__day--selected {
  background-color: var(--color-primary-light);
}

/* Day navigated to by keyboard, using arrows */
.common_picker_date .react-datepicker__day--keyboard-selected {
  background-color: var(--color-primary-light);
  color: var(--color-text-alt);
}

/* Previous month arrow */
.common_picker_date .react-datepicker__navigation--previous {
  /* It's a CSS triangle, that's why we're changing the border color */
  border-right-color: var(--color-primary-light);
}
/* Next month arrow */
.common_picker_date .react-datepicker__navigation--next {
  /* It's a CSS triangle, that's why we're changing the border color */
  border-left-color: var(--color-primary-light);
}

/* For some reason, clicking a disabled date still showed focus styles previously */
.common_picker_date .react-datepicker__day--disabled:focus {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Common/PickerDate/styles.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;;EAEE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,iBAAiB;AACjB;EACE,4CAA4C;AAC9C;;AAEA,+CAA+C;AAC/C;EACE,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,oEAAoE;EACpE,8CAA8C;AAChD;AACA,qBAAqB;AACrB;EACE,oEAAoE;EACpE,6CAA6C;AAC/C;;AAEA,mFAAmF;AACnF;EACE,aAAa;AACf","sourcesContent":["/* Wrapper for the entire picker */\n.common_picker_date .react-datepicker {\n  border: none;\n  width: 100%;\n}\n\n/* Container for all dates and header */\n.common_picker_date .react-datepicker__month-container {\n  width: 100%;\n}\n\n/* Portion containing month name and arrows */\n.common_picker_date .react-datepicker__header {\n  background-color: transparent;\n  border: none;\n}\n\n/* Container for all dates */\n.common_picker_date .react-datepicker__month {\n  margin: var(--spacing-tiny) 0;\n}\n\n/* Single day (numbers) */\n.common_picker_date .react-datepicker__day-name,\n.common_picker_date .react-datepicker__day {\n  margin: var(--spacing-tiny);\n  width: calc(100% / 7 - 2 * var(--spacing-tiny));\n}\n\n/* Selected day */\n.common_picker_date .react-datepicker__day--selected {\n  background-color: var(--color-primary-light);\n}\n\n/* Day navigated to by keyboard, using arrows */\n.common_picker_date .react-datepicker__day--keyboard-selected {\n  background-color: var(--color-primary-light);\n  color: var(--color-text-alt);\n}\n\n/* Previous month arrow */\n.common_picker_date .react-datepicker__navigation--previous {\n  /* It's a CSS triangle, that's why we're changing the border color */\n  border-right-color: var(--color-primary-light);\n}\n/* Next month arrow */\n.common_picker_date .react-datepicker__navigation--next {\n  /* It's a CSS triangle, that's why we're changing the border color */\n  border-left-color: var(--color-primary-light);\n}\n\n/* For some reason, clicking a disabled date still showed focus styles previously */\n.common_picker_date .react-datepicker__day--disabled:focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
